import { defineStore } from 'pinia';
import { library } from "@common/library/library";

let allowedActions = [];
let getAllowedActions = () => {
    if (!allowedActions.length) {
        let disabled = ['checkSelect', 'runChainedActions', 'iframeProcessSubmit'];
        let allActions = actionStore.actions;
        let allActionOptions = actionStore.state.actionOptions;
        for (let tmpAct in allActions) {
            if (disabled.indexOf(tmpAct) !== -1) continue;
            let actionInOptions = allActionOptions.find((tmp) => tmp.value === tmpAct);
            if (!actionInOptions || actionInOptions.useInNav) {
                allowedActions.push(tmpAct);
            }
        }
    }
    return allowedActions;
};

const navigationStore = defineStore('navigationStore', {
    state: () => ({
        windows: [],
        actions: [],
        rightSidebars: []
    }),
    getters: {
        getWindows(state) {
            return () => state.windows;
        },
        getActions(state) {
            return () => state.actions;
        },
        getRightSidebars(state) {
            return () => state.rightSidebars;
        },
    },
    actions: {
        restoreUrl() {
            let tmpWindows = typeof router?.currentRoute?.value?.query?.windows === 'string' && JSON.parse(router.currentRoute.value.query.windows);
            let tmpActions = typeof router?.currentRoute?.value?.query?.actions === 'string' && JSON.parse(router.currentRoute.value.query.actions);
            let tmpRightSidebars = typeof router?.currentRoute?.value?.query?.rightSidebars === 'string' && JSON.parse(router.currentRoute.value.query.rightSidebars);
            if (!Array.isArray(tmpWindows)) tmpWindows = [];
            if (!Array.isArray(tmpActions)) tmpActions = [];
            if (!Array.isArray(tmpRightSidebars)) tmpRightSidebars = [];
            for (let i in tmpWindows) {
                window.open(tmpWindows[i].url, tmpWindows[i].name, tmpWindows[i].features);
            }
            for (let i in tmpActions) {
                let tmpAction = tmpActions[i];
                if (tmpAction.params) {
                    actionStore[tmpAction.action](tmpAction.params);
                } else {
                    actionStore[tmpAction.action]();
                }
            }
            if (tmpRightSidebars.length) this.rightSidebars = tmpRightSidebars;
        },
        calculateUrl() {
            let tmpQuery = {};
            if (!library.objIsEmpty(this.windows)) tmpQuery['windows'] = JSON.stringify(this.windows);
            if (!library.objIsEmpty(this.actions)) tmpQuery['actions'] = JSON.stringify(this.actions);
            if (!library.objIsEmpty(this.rightSidebars)) tmpQuery['rightSidebars'] = JSON.stringify(this.rightSidebars);
            router.push({
                path: router.currentRoute.value.path,
                query: tmpQuery
            });
        },
        openWindow(url, name, features) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            if (!this.windows.some((window) => window.name === name)) {
                this.windows.push({
                    name,
                    url,
                    features
                });
                this.calculateUrl();
            }
        },
        editWindow(name, params) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            let windowIndex = this.windows.findIndex((window) => window.name === name);
            if (windowIndex >= 0) {
                for (let prop in params) {
                    this.windows[windowIndex][prop] = params[prop];
                }
                this.calculateUrl();
            }
        },
        closeWindow(name) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            let windowIndex = this.windows.findIndex((window) => window.name === name);
            if (windowIndex >= 0) {
                this.windows.splice(windowIndex, 1);
                this.calculateUrl();
            }
        },
        addAction(actionName, actionParams) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            getAllowedActions();
            if (allowedActions.indexOf(actionName) === -1) return;
            if (!this.actions.some((action) => action.action === actionName && library.isEqualObj(action.params, actionParams))) {
                this.actions.push({
                    action: actionName,
                    params: actionParams
                });
                this.calculateUrl();
            }
        },
        removeAction(actionName, actionParams) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            let actionIndex = this.actions.findIndex((action) => action.action === actionName && library.isEqualObj(action.params, actionParams));
            if (actionIndex >= 0) {
                this.actions.splice(actionIndex, 1);
                this.calculateUrl();
            }
        },
        openInRightSidebar(params) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            if (!this.rightSidebars.some((rightSidebar) => library.isEqualObj(rightSidebar, params))) {
                this.rightSidebars.push(params);
                this.calculateUrl();
            }
        },
        removeFromRightSidebar(params) {
            if (typeof PROJECT_WITH_ROUTER === 'undefined') return;
            let rightSidebarIndex = this.rightSidebars.findIndex((rightSidebar) => library.isEqualObj(rightSidebar, params));
            if (rightSidebarIndex >= 0) {
                this.rightSidebars.splice(rightSidebarIndex, 1);
                this.calculateUrl();
            }
        }
    }
});

if (typeof PROJECT_WITH_ROUTER !== 'undefined') {
    window.open = (function (open) {
        return function (url, name, features) {
            let openedWindow = open.call(window, url, name, features);
            openedWindow.onunload = () => {
                window.navigationStore().closeWindow(name);
            };
            window.navigationStore().openWindow(url, name, features);
            return openedWindow;
        };
    }(window.open));

    /* window.onbeforeunload = () => {
        let getOpenedWindows = navigationStore().getWindows();
        debugger;
    }; */
}

let getTopNavigationStore = (winObj) => {
    // all manipulation should go in main window
    try {
        while (winObj !== window.opener) winObj = window.opener;
        return winObj?.navigationStore || navigationStore;
    } catch (e) {
        return navigationStore;
    }
};

window.navigationStore = getTopNavigationStore(window);

export { navigationStore };
